const backendUrl = "https://data.physitask.com";

export default backendUrl;
